export const TABS = {
  BALANCE_SHEET: 1,
  INCOME_STATEMENT: 2,
  CASH_FLOW_STATEMENT: 3,
};

export const TIME_FILTERS = {
  QUARTERLY: 1,
  YEARLY: 2,
};

export const LEVELS = {
  PARENT: 1,
  CHILD: 2,
  THREE: 3,
  FOUR: 4,
};

export const TYPES = {
  CHART: 'chart',
};

export const NUMBER_FLEXIBLE = 5;

export const DEFAULT_CODE = 'SSI';
